export const TIME_ALLOCATION_CONSTANTS = {
  locationID: {
    managementLocation: 283,
  },
  serviceID: {
    roleRequired: 2,
    managementLockedService: 4,
  },
};

export interface TimeAllocation {
  allocationID: number;
  employeeID: number;
  locationID: number;
  serviceDate: Date;
  hoursWorked: number;
  hoursTraveled: number;
  allocationNote: string;
  allocationServiceID: number;
  allocationRoleID: number;
}

export interface TimeAllocationDetail extends TimeAllocation {
  locationShortName: string;
  serviceDescription: string;
  roleDescription: string;
}

export interface TimeAllocationLocation {
  locationID: number;
  locationShortName: string;
}

export interface TimeAllocationWorkedService {
  allocationServiceID: number;
  serviceDescription: string;
}

export interface TimeAllocationRole {
  allocationRoleID: number;
  roleDescription: string;
}